import React from 'react';
import { CircleMarker, Polygon, Polyline, Popup } from 'react-leaflet';
import { splitPoints, splitPosition } from 'actions/spectrumActions';
import MAP from 'constants/mapConstants';

/**
 * This component uses a geometric field's coordinate values to draw geometries 
 * in a MapContainer component
 */
export default function GeometryFieldComponent({ field }) {
  return field.values.map((v, i) => {
    let pointStrings = splitPosition(v);
    if (pointStrings.length === 1){
      return (
        <CircleMarker
          center={splitPoints(pointStrings, false)[0]}
          removeMarker={() => field.actions.removeValue(field.predicate, i)}
          color={MAP.DEFAULT_COLOR}
          radius={MAP.MARKER_RADIUS}
          key={i}>
          <Popup>
            {v}
          </Popup>
        </CircleMarker>
      )
    }
    else if (pointStrings[0] === pointStrings[pointStrings.length - 1]){
      return (
        <Polygon
          positions={splitPoints(pointStrings, true)}
          removeMarker={() => field.actions.removeValue(field.predicate, i)}
          color={MAP.DEFAULT_COLOR}
          key={i}>
          <Popup>
            {v}
          </Popup>
        </Polygon>
      )
    }
    else{
      return (
        <Polyline
          positions={splitPoints(pointStrings, false)}
          removePolyline={() => field.actions.removeValue(field.predicate, i)}
          color={MAP.DEFAULT_COLOR}
          key={i}>
          <Popup>
            {v}
          </Popup>
        </Polyline>
      )
    }
  })
}